module.exports = __webpack_public_path__ + "img/C73551.f3859916.png";